/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Integrations_Credentials_Dialog_Replace_TitleInputs */



/**
* | output |
* | --- |
* | "Replace credentials for {name}" |
*
* @param {Integrations_Credentials_Dialog_Replace_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_credentials_dialog_replace_title = /** @type {((inputs: Integrations_Credentials_Dialog_Replace_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Credentials_Dialog_Replace_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Zugangsdaten für ${i?.name} ersetzen`)
	return /** @type {LocalizedString} */ (`Replace credentials for ${i?.name}`)
});